import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import deals from "../../assets/deals.png";
import { BsBarChartFill } from "react-icons/bs";
import { BiSolidCategory, BiLogOut } from "react-icons/bi";
import { MdCategory } from "react-icons/md";
import { TbShoppingCartFilled } from "react-icons/tb";
import { FaBuilding, FaWallet } from "react-icons/fa6";
import { FaCashRegister, FaBoxOpen, FaUser, FaTicketAlt, FaMoneyBillWave, FaUserFriends } from "react-icons/fa";
import { FaSliders } from "react-icons/fa6";
import { BiSolidCategoryAlt } from "react-icons/bi";
import { AiFillPieChart } from "react-icons/ai";
import { IoPeople } from "react-icons/io5";
import { MdCampaign } from "react-icons/md";
import { GiMagnet } from "react-icons/gi";


function Sidebar({ handleLogout }) {
  const navigate = useNavigate();
  const handelLogOutClick = () => {
    handleLogout();
    navigate("/");
  };

  const [leadMenuOpen] = useState(false);

  const [activeSubmenu] = useState(null);

  return (
    <nav
      className="navbar show navbar-vertical navbar-expand-lg p-0 navbar-light border-bottom border-bottom-lg-0 border-end-lg"
      id="navbarVertical"
    >
      <div
        className="container-fluid"
        style={{ height: "100vh", overflow: "auto" }}
      >
        <button
          className="navbar-toggler mx-2 p-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarCollapse"
          aria-controls="sidebarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <NavLink
          className={`navbar-brand nav-logo logo_ats py-lg-2 px-lg-6 m-0 d-flex align-items-center justify-content-center gap-3 ${
            leadMenuOpen || activeSubmenu ? "active" : ""
          }`}
          to="/"
          // style={{position:"fixed",top:"0", minWidth:'18.1%'}}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={deals}
              alt="deals"
              className="img-fluid sidebar-logo"
              style={{
                width: "40px",
                height: "40px",
              }}
            />
          </div>
          <p className="text-white">DealsMachi</p>
        </NavLink>
        <div
          className="collapse navbar-collapse"
          id="sidebarCollapse"
          // style={{ marginTop: "5rem" }}
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/dashboard">
                <BsBarChartFill />
                Dashboard
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/slider">
                <FaSliders />
                Slider
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/leadmagnet">
                <GiMagnet  />
                Lead Magnet
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/campaign">
                <MdCampaign />
                Campaign
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/campaignsubmission">
                <MdCampaign />
                Campaign Submission
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/categorygroup">
                <BiSolidCategoryAlt />
                Category Groups
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/categories">
                <BiSolidCategory />
                Categories
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/subcategories">
                <BiSolidCategory />
                Sub Categories
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/dealcategories">
                <MdCategory />
                Deal Categories
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/voucher">
                <FaTicketAlt  />
               Voucher
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/products">
                <TbShoppingCartFilled />
                Deals
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/shop">
                <FaBuilding />
                Company
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/user">
                <FaUser />
                User
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/order">
                <FaBoxOpen />
                Orders
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/referrer_vendor">
                <IoPeople />
                Referrer
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/referrer">
                <AiFillPieChart />
                Referral Amount
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/freeCash">
                <FaCashRegister />
                Free Cash
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/user-wallets">
                <FaWallet />
                User Wallets
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/affiliate">
                <FaUserFriends  />
                Affiliate
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/affiliate-payout">
                <FaMoneyBillWave  />
               Affiliate Payout
              </NavLink>
            </li>
          </ul>
          <div className="ps-4 mt-auto w-100 mb-4">
            <div className="navbar-nav">
              <div className="nav-item">
                <button
                  to={"#"}
                  style={{ width: "100%" }}
                  className="nav-link ps-6 logout_button"
                  onClick={handelLogOutClick}
                >
                  <BiLogOut />
                  &nbsp;&nbsp; Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Sidebar;
